import "./App.css";

// React
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// Components
import AuthContainer from "./Components/Authentication/AuthContainer";
//import Maintenance from "Components/Maintenance";
import NotificationSnackbar from "Components/NotificationSnackbar";
import ScrollToTop from "Components/Scroll/ScrollToTop";
import { MBSPortal } from "Components/Users/MBS";
import { MBSLayout, MBSNotFound } from "Components/Users/MBS/MBSPortal";
import { MBSReason } from "Components/Users/MBS/Pages/Booking";
import {
  MBSAppointments,
  SearchPage,
  MBSHomePage,
  MBSPatientRegistration,
} from "Components/Users/MBS/Pages";

import {
  MBSAuthRedirect,
  MBSUnauthenticatedRoute,
  MBSProtectedRoute,
  MBSLoginPage,
} from "Components/Users/MBS/Auth";
import AuthDomainRouter from "Auth/AuthDomainRouter";

// Material UI
import { ThemeProvider } from "@mui/material/styles";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers";

// Libraries
import { useTranslation } from "react-i18next";
import { appTheme } from "Theme";

const router = createBrowserRouter([
  {
    element: <AuthDomainRouter />,
    children: [
      {
        path: "/mbs",
        element: <MBSLayout />,
        children: [
          { index: true, element: <MBSAuthRedirect /> },
          {
            element: <MBSUnauthenticatedRoute />,
            children: [
              {
                path: "login",
                element: <MBSLoginPage />,
              },
            ],
          },
          {
            element: <MBSProtectedRoute />,
            children: [
              {
                element: <MBSPortal />,
                children: [
                  { path: "home", element: <MBSHomePage /> },
                  { path: "search", element: <SearchPage /> },
                  { path: "reason", element: <MBSReason /> },
                  {
                    path: "patient-registration",
                    element: <MBSPatientRegistration />,
                  },
                  { path: "appointments", element: <MBSAppointments /> },
                  { path: "*", element: <MBSNotFound /> },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "*",
        element: (
          <div className="App">
            <ScrollToTop />
            <AuthContainer />
          </div>
        ),
      },
    ],
  },
]);

const App = () => {
  const { i18n } = useTranslation();
  return (
    // <Maintenance />
    <LocalizationProvider
      dateAdapter={AdapterLuxon}
      adapterLocale={i18n.language || "en"}
    >
      <ThemeProvider theme={appTheme}>
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
        <NotificationSnackbar />
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default App;
